const listOfPatent = [
  {
    id: 1,
    year: 2022,
    submenu: [
      {
        title:
          "A Wireless Electromyography Measurement System with Flexible Capacitive Biosensor",
        author: `Ng Charn Loong, Mamun Bin Ibne Reaz, Muhammad E. H. Chowdhury`,
        patentState: `Accepted for provisional patent`,
      },
      {
        title:
          "Self-DFUNet -A Novel Machine Learning Model for stratification of Early Diabetic Foot complication using Thermogram Images",
        author:
          " Amith Khandakar, Muhammad E.H. Chowdhury, Mamun Bin Ibne Reaz, Mamun Bin Ibne Reaz, Sawal Hamid Md Ali, Serkan Kiranyaz,  Rashad Alfkey,  Ahmad Ashrif A. Bakar, Rayaz A. Malik, Mohamed Arselene Ayari, Moajjem Hossain Chowdhury, Kanchon Kanti Podder",
        patentState: `Accepted for provisional patent`,
      },
      {
        title:
          "Robust and Novel Attention Guided MultiResUnet Model for 3D Ground Reaction Force and Moment Prediction from Foot Kinematics",
        author:
          "Md. Ahasan Atick Faisal, Sakib Mahmud, Muhammad E. H. Chowdhury, Amith Khandakar, Mosabber Uddin Ahmed, Mohammed Alhatou",
        patentState: `Under review`,
      },
      {
        title: `A Deep Learning Model to Remove Motion Artifacts from Electroencephalography (EEG) Signals`,
        author: `Sakib Mahmud, Md Shafayet Hossain, Muhammad E. H. Chowdhury, Mamun Bin Ibne Reaz`,
        patentState: `Accepted for provisional patent`,
      },
      {
        title: `A Wearable Non-invasive Blood Glucose Monitoring System`,
        author: `mazun Alshahwani, Noora Al Bordeni, Fatima Al-Kaabi, Sara Al-Mohannadi, Khalid Abualsaud, Muhammad E. H. Chowdhury, Elias Yaacoub, Nizar Zorba`,
        patentState: `Under review`,
      },
    ],
  },
  {
    id: 2,
    year: 2020,
    submenu: [
      {
        title: `A multidimensional ventilatory circuit system derived from a single ventilator source with antimicrobial provision`,
        author: "R Mazhar, MEH Chowdhury",
        details: `US Patent App. 63/001,337`,
      },
      {
        title: `Infection Map Generation and Pneumonia Detection from Chest XRAY Images`,
        author:
          "Serkan KIRANYAZ, Mehmet Yamac, Mete Ahishali, Aysen Degerli Ahishali, Muhammad Enamul Hoque Chowdhury, Tahir Hamid, Rashid Mazhar, Moncef Gabbouj",
        details: `US Patent App. 63/133,151`,
      },
    ],
  },
];
export default listOfPatent;
